export default __webpack_public_path__ + "static/media/1.0a5e54a7.png";